import { UserType, UserRole } from './constants';

export enum UserPreferredMfaMethod {
  TOTP = 'totp',
  SMS = 'sms',
  EMAIL = 'email',
}

export enum ApplicantRole {
  PRIMARY = 'primary',
  CO_APPLICANT = 'co_applicant',
  FULL_APPLICANT = 'full_applicant',
}

export interface User {
  id: number;
  /**
   * @deprecated DONT use this
   * TODO: Tech Debt: REL-9896 Remove unused columns on User Table.
   */
  username: string;
  email?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  phone?: string | null;
  roles?: UserRole[];
  resetPasswordKey?: string | null;
  resetPasswordKeySetAt?: Date | null;
  type: UserType;
  /**
   * @deprecated DONT use this, use @/utils/user getUserDealersIds and related methods.
   * TODO: Tech Debt: REL-9896 Remove unused columns on User Table.
   */
  dealer_id?: string | null;
  crmUserId?: string | null;
  crmLogin?: string | null;
  crmPassword?: string | null;
  fniUserId?: string | null;
  notificationToken?: string | null;
  markedOnlineAvailabilityAt?: Date | null;
  verified?: boolean | null;
  personaId?: string | null;
  /*
   * Can be `Date` when working with a user on the backend, but serialized users will
   * have this property be a `string`
   */
  lockedUntil?: Date | string | null;
  preferredMfaMethod?: UserPreferredMfaMethod | null;
  updatedAt?: Date | string | null;
  deletedAt?: Date | string | null;
  applicantRole?: ApplicantRole;
}

export interface UserWithDealers extends User {
  Dealers: {
    id: string;
    name: string;
    UserDealer: UserDealer;
  }[];
}

type UserSearchUserFields = Pick<
  User,
  | 'id'
  | 'firstName'
  | 'lastName'
  | 'email'
  | 'phone'
  | 'roles'
  | 'type'
  | 'lockedUntil'
  | 'personaId'
  | 'verified'
  | 'updatedAt'
>;

export type UserSearchResult = UserSearchUserFields & {
  Dealers: {
    id: string;
    name: string;
    UserDealer: { crmUserId: string };
  }[];
  invite?: {
    expiresAt: string;
  };
};

// dealer_id and crmUserId are part of the UserDealer table
// hence we are extending the User type here
export interface Client extends User {
  dealer_id: string;
  crmUserId?: string | null;
  type: UserType.CLIENT;
}

export interface Employee extends User {
  type: UserType.EMPLOYEE;
}

export interface Advanced extends User {
  type: UserType.ADVANCED;
}

export interface UserDealer {
  user_id: number;
  dealer_id: string;
  crmUserId?: string;
  crmLogin?: string;
  crmPassword?: string;
  fniUserId?: string;
}

export interface RawCRMUser {
  email: string;
  firstName: string;
  lastName: string;
  phone?: string;
  roles: UserRole[];
  crmUserId: string;
  notificationAddress?: string;
}

export const isEmployee = (user: { type: UserType }): user is Employee => {
  return user.type === UserType.EMPLOYEE;
};

export const isClient = (user: { type: UserType }): user is Client => {
  return user.type === UserType.CLIENT;
};

export const isClientOrAdvancedUser = (user: {
  type: UserType;
}): user is Client | Advanced => {
  return user.type === UserType.CLIENT || user.type === UserType.ADVANCED;
};

export const isEmployeeOrAdvancedUser = (user: { type: UserType }) =>
  user.type === UserType.EMPLOYEE || user.type === UserType.ADVANCED;
